import { useState } from "react";
import { Tabs, Page } from "@shopify/polaris";
import FulfilmentOrders from "./components/fulfilmentOrders";
import FulfilmentProduct from "./components/fulfilmentProduct";
import FulfilmentCalendar from "./components/fulfilmentCalendar";
import { useNavigate } from "react-router-dom";
import ManualDhlPickupModal from "./components/manualDhlPickupModal";
import { Toasts } from "../../shared/components/toasts/toasts";

export default function FulfilmentPage() {
  const url = new URL(window.location.href);
  const tabIndex = parseInt(url.searchParams.get("tab") + "") || 0;

  const [selected, setSelected] = useState(tabIndex);
  const [manualPickupModalOpen, setManualPickupModalOpen] = useState(false);
  const [toast, setToast] = useState(null);
  const navigate = useNavigate();

  const handleTabChange = (selectedTabIndex) => {
    setSelected(selectedTabIndex);
    navigate(`/fulfilment?tab=${selectedTabIndex}`);
  };

  const tabs = [
    { id: "Orders", content: "Orders to fulfil", component: <FulfilmentOrders /> },
    { id: "fulfilement-products", content: "Material explorer", component: <FulfilmentProduct /> },
    { id: "fulfilment-calendar", content: "Fulfilment calendar", component: <FulfilmentCalendar /> },
  ];
  const selectedTabIndex = tabs[selected] ? selected : 0;

  return (
    <Page
      title="Fulfilment"
      fullWidth
      secondaryActions={[
        {
          content: "Manual DHL pickup",
          onAction: () => setManualPickupModalOpen(true),
        },
      ]}
    >
      <ManualDhlPickupModal open={manualPickupModalOpen} onClose={() => setManualPickupModalOpen(false)} setToast={setToast} />
      <Toasts
        toast={toast}
        setToast={setToast}
        toastContent="Manual DHL pickup created"
        errorToastContent="Could not create the manual DHL pickup"
      />
      <Tabs tabs={tabs} selected={selectedTabIndex} onSelect={handleTabChange}>
        {tabs[selectedTabIndex].component}
      </Tabs>
    </Page>
  );
}
